import { render, staticRenderFns } from "./orderNumStatistic.vue?vue&type=template&id=53f9ceb1&scoped=true"
import script from "./orderNumStatistic.vue?vue&type=script&lang=js"
export * from "./orderNumStatistic.vue?vue&type=script&lang=js"
import style0 from "./orderNumStatistic.vue?vue&type=style&index=0&id=53f9ceb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9ceb1",
  null
  
)

export default component.exports